// src/utils/getDefaultPhoto.js

const normalizeGender = (gender) => {
    if (!gender) return 'U';
    const value = String(gender).trim().toLowerCase();

    if (value === 'm' || value === 'male') return 'M';
    if (value === 'f' || value === 'female') return 'F';

    return 'U';
};

export function getDefaultPhoto(gender) {
    const normalized = normalizeGender(gender);

    if (normalized === 'M') {
        return require('@/assets/defaults/default_photo_male.svg');
    } else if (normalized === 'F') {
        return require('@/assets/defaults/default_photo_female.svg');
    }

    return require('@/assets/defaults/default_photo_unknown.svg');
}

export function getPhotoSrcWithFallback({ photoSrc, photoPath, profileImage, sex, gender } = {}) {
    const candidate = [photoSrc, photoPath, profileImage].find(value => {
        if (typeof value === 'string') {
            return value.trim() !== '';
        }
        return Boolean(value);
    });

    if (candidate) {
        return candidate;
    }

    return getDefaultPhoto(sex || gender);
}
